
import { PropTypes } from 'prop-types';
const ResponsiveTable = ({ headers,mobile, contents,headerBg="border-gray-300/50 bg-indigo-100" }) => {
    //make cell percentage equal to 100%
    const cellPercentage = 100 / headers?.length

    
    return (
        <table className='table table-auto w-full overflow-x-auto max-w-full'>
            <thead >
                <tr >
                    {
                        headers?.map((header, index) => (
                            <th key={index} className={`text-left lg:border-2 lg:w-[${cellPercentage}%]  p-4 ${headerBg}`}>{header}</th>
                        ))
                    }
                </tr>
            </thead>
            <tbody>
                {
                    contents?.map((content, index) => (
                        <tr key={index}>
                            {
                               
                                content != null && content?.map((data, index) => (
                                    <td data-label={mobile ? mobile[index] : headers[index]} className={`text-left  self-stretch lg:border-2 lg:w-[${cellPercentage}%]  p-4 bg-slate-50`} key={index}>{data}</td>
                                ))
                            }
                        </tr>
                    ))
                }
            </tbody>
        </table>
    )
}
ResponsiveTable.propTypes = {
    headers: PropTypes.array,
    mobile: PropTypes.array,
    contents: PropTypes.array,
    headerBg: PropTypes.string
}
export default ResponsiveTable